import * as React from 'react';
import {FormattedMessage, injectIntl} from 'react-intl';
import {PlatformOptions} from '@models/index';
import Search, {SearchInputType} from '../custom/Search';


interface SearchInputProps {
  search: (filter: object) => any;
  form: any;
  intl: any;
}

const SearchHyperLinkMenusComponent: React.FC<SearchInputProps> = props => {
  const {search} = props;
  
  const inputs = [{
    name: "query",
    label: <FormattedMessage id="app.title" defaultMessage={`Search By Title`}/>,
    type: SearchInputType.TEXT,
    size: 8
  }, {
    name: "is_active",
    label : <FormattedMessage id="app.status" defaultMessage={`Status`}/>,
    type : SearchInputType.SELECT,
    options : [{
      label : <FormattedMessage id="app.active" defaultMessage={`Active`}/>,
      value : true
    },{
      label : <FormattedMessage id="app.inactive" defaultMessage={`Inactive`}/>,
      value : false
    }],
    size: 8
  }, {
    name: "client_platform",
    label: <FormattedMessage id="app.select_platform" defaultMessage={`Select Platform`}/>,
    type: SearchInputType.SELECT,
    options : PlatformOptions,
    size: 8
  }];
  
  return <Search inputs={inputs} search={search}/>
  
};

export default SearchHyperLinkMenusComponent;